export default import.meta.ROLLUP_FILE_URL_1CJRyX6Wj_OvI6D8yL7r8A